import { createApiClient, type ApiClientInstance } from '@bonboca/api-sdk';

import { getAccessToken } from './auth';
import { env } from './env';
import { getStoredGuestOrderToken } from './guestOrders';

let cachedClient: ApiClientInstance | undefined;

export function getApiClient(): ApiClientInstance {
  if (!cachedClient) {
    cachedClient = createApiClient({
      baseUrl: env.apiBaseUrl,
      getAccessToken,
      getGuestOrderToken: getStoredGuestOrderToken,
    });
  }
  return cachedClient;
}

export { ApiError, NotImplementedError, isNotImplemented } from '@bonboca/api-sdk';
